export default "__VITE_ASSET__CEpb8nIA__"